import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Typography, Button } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { rem } from '@helpers';
import { RoundIconWarning } from '@icons';
import { useNavigation } from '@navigation';
import { Link } from '@components';
export interface RequestToCallWarningProps {
	newRequestContact?: () => void;
	tryAgainButton?: () => void;
}
/* cspell: disable */
export const RequestToCallWarning: React.FC<RequestToCallWarningProps> = (props) => {
	const { newRequestContact, tryAgainButton } = props;
	const t = useTranslation();
	const { navigate } = useNavigation();
	return (
		<Box
			styles={{
				flexDirection: 'column',
				minHeight: '100%',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<Box>
				<RoundIconWarning />
			</Box>
			<Box styles={{ margin: rem(24, 0, 48, 0), width: rem(790), textAlign: 'center' }}>
				<Typography appearance="headline-200-02">{t('placeholders.requestToCallWarning.title')}</Typography>
			</Box>
			<Box>
				<Button onPress={tryAgainButton}>{t('placeholders.requestToCallWarning.button.tryAgain.title')}</Button>
			</Box>
			<Box styles={{ margin: rem(24, 0, 48, 0) }}>
				<Button appearance="secondary" onPress={newRequestContact}>
					{t('placeholders.requestToCallWarning.button.newRequestContract.title')}
				</Button>
			</Box>
			<Box>
				<Link onClick={() => navigate('root')}>
					<Typography>{t('general.back')}</Typography>
				</Link>
			</Box>
		</Box>
	);
};
